import React from 'react';

interface AiBadgeProps {
  title?: string;
}

const AiBadge: React.FC<AiBadgeProps> = ({ title = 'Generated by AI. Edit to convert to a manual value.' }) => {
  return (
    <span
      title={title}
      style={{
        display: 'inline-block',
        marginLeft: 6,
        padding: '1px 6px',
        fontSize: 10,
        fontWeight: 600,
        lineHeight: '14px',
        letterSpacing: 0.5,
        color: '#1d4ed8',
        background: '#dbeafe',
        border: '1px solid #93c5fd',
        borderRadius: 'var(--radius)',
        verticalAlign: 'middle'
      }}
    >
      AI
    </span>
  );
};

export default AiBadge;
